import { Navigate, Route, Routes } from 'react-router';
import { useAuth } from './lib/auth';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/Login';
import { DashboardPage } from './pages/Dashboard';
import { CustomersPage } from './pages/Customers';
import { CustomerFormPage } from './pages/CustomerForm';
import { CustomerProfilePage } from './pages/CustomerProfile';
import { ImportCustomersPage } from './pages/ImportCustomers';
import { DocumentsPage } from './pages/Documents';
import { InvoicesPage } from './pages/Invoices';
import { FinancePage } from './pages/Finance';
import { ReviewPage } from './pages/Review';
import { AutomationPage } from './pages/Automation';
import { SettingsPage } from './pages/Settings';
import { StatementPage } from './pages/Statement';
import { FollowUpsPage } from './pages/FollowUps';
import { DuplicatesPage } from './pages/Duplicates';
import { BillingPage } from './pages/Billing';
import { GoalsPage } from './pages/Goals';
import { ProfitPage } from './pages/Profit';
import { SubstitutesPage } from './pages/Substitutes';
import { WorkPlanPage } from './pages/WorkPlan';
import { ProductsPage } from './pages/Products';
import { ProductImportPage } from './pages/ProductImport';
import { ProductMatchingPage } from './pages/ProductMatching';
import { PriceImportPage } from './pages/PriceImport';
import { OrderEditorPage } from './pages/OrderEditor';
import { ArchiveReviewPage } from './pages/Archive';
import { OrdersPage } from './components/Orders';
import { PickListPage, PickPage } from './pages/Pick';
import { InventoryPage, StockCountsPage } from './pages/Inventory';
import { StockCountPage } from './pages/StockCount';
import { ReceiptPage, ReceiptsPage } from './pages/Receipts';
import { DeliveryProofPage } from './components/DeliveryProof';

export function App() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="login">
        <span className="spinner" style={{ color: 'var(--muted)' }} />
      </div>
    );
  }
  if (!user) return <LoginPage />;
  return (
    <Routes>
      {/* the picking screen stands alone — full width on a phone */}
      <Route path="pick/:kind/:id" element={<PickPage />} />
      <Route path="inventory/count/:id" element={<StockCountPage />} />
      <Route path="delivery/:documentId" element={<DeliveryProofPage />} />
      <Route element={<Layout />}>
        <Route path="pick" element={<PickListPage />} />
        <Route index element={<DashboardPage />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="customers/new" element={<CustomerFormPage />} />
        <Route path="customers/import" element={<ImportCustomersPage />} />
        <Route path="customers/:id" element={<CustomerProfilePage />} />
        <Route path="customers/:id/edit" element={<CustomerFormPage />} />
        <Route path="customers/:id/statement" element={<StatementPage />} />
        <Route path="today" element={<WorkPlanPage />} />
        <Route path="followups" element={<FollowUpsPage />} />
        <Route path="duplicates" element={<DuplicatesPage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="goals" element={<GoalsPage />} />
        <Route path="profit" element={<ProfitPage />} />
        <Route path="inventory" element={<InventoryPage />} />
        <Route path="inventory/counts" element={<StockCountsPage />} />
        <Route path="inventory/receipts" element={<ReceiptsPage />} />
        <Route path="inventory/receipts/:id" element={<ReceiptPage />} />
        <Route path="profit/substitutes" element={<SubstitutesPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="products/import" element={<ProductImportPage />} />
        <Route path="products/matching" element={<ProductMatchingPage />} />
        <Route path="products/prices" element={<PriceImportPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="archive" element={<ArchiveReviewPage />} />
        <Route path="orders/:id" element={<OrderEditorPage />} />
        <Route path="invoices" element={<InvoicesPage />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="finance" element={<FinancePage />} />
        <Route path="review" element={<ReviewPage />} />
        <Route path="automation" element={<AutomationPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
